// The issues the list showed last, in its order, so an issue's page can go to the one before or
// after it (‹ ›, j/k, Console D). Kept for this tab only; a page opened from a link has none.
const KEY = 'apsio.issueOrder'

export function setIssueOrder(projectId: string, ids: string[]): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ projectId, ids }))
  } catch {
    // Storage blocked: the issue page shows no pager.
  }
}

/** The list order for this project, or none. */
export function issueOrder(projectId: string): string[] {
  try {
    const v = JSON.parse(sessionStorage.getItem(KEY) ?? 'null') as {
      projectId?: unknown
      ids?: unknown
    } | null
    return v && v.projectId === projectId && Array.isArray(v.ids)
      ? v.ids.filter((x): x is string => typeof x === 'string')
      : []
  } catch {
    return []
  }
}
